module.exports = __webpack_public_path__ + "static/fadi-mozuannar.8f84c5c3.svg";